
import { ActivityLog } from "@/models/LearnTypes";

/**
 * Calculate total XP from activity logs
 */
export const calculateTotalXP = (activityLogs: ActivityLog[]): number => {
  if (!activityLogs || !activityLogs.length) return 0;
  
  // Sum up all xpEarned values from activity logs
  return activityLogs.reduce((total, activity) => {
    // Ensure xpEarned is a number before adding
    const xpEarned = typeof activity.xpEarned === 'number' ? activity.xpEarned : 0;
    return total + xpEarned;
  }, 0);
};
